// 261010 UI1a → lượt 5 — còn lại MỘT dòng meta nhỏ (`summaryLineOf` rút gọn) nằm trong hàng trên cùng (WorkflowTopBar). Không còn thẻ lớn, nhãn «Plan làm phim» hay tên lặp lại; nút chính ở WorkflowTopBar.
import React from 'react';
import type { WorkflowStatus } from '../../types/filmWorkflow';
import { compactSummaryOf } from './workflowHeroUtils';
import { summaryLineOf } from './workflowPrimaryPolicy';

interface Props { status: WorkflowStatus }

/** Làm đậm các số dạng "9/9" trong dòng tóm tắt. */
const boldNumbers = (line: string): React.ReactNode[] =>
  line.split(/(\d+\/\d+)/g).map((p, i) => (/^\d+\/\d+$/.test(p) ? <b key={i}>{p}</b> : <React.Fragment key={i}>{p}</React.Fragment>));

const WorkflowHero: React.FC<Props> = ({ status }) => (
  <span className="wf-sum wf-top-meta" data-testid="wf-summary-line">{boldNumbers(compactSummaryOf(summaryLineOf(status)))}</span>
);

export default WorkflowHero;
